module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper"
  }, _vm._l((_vm.masterArray), function(item) {
    return _c('div', [_c('md-card', [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(item.priimek_in_ime_zdravnika))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(_vm._s(item.naslov_izvajalca_prvi_del))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v(_vm._s(item.naslov_izvajalca_drugi_del))]), _vm._v(" "), _c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("\r\n                            TIP: \r\n                            "), (item.ZZZS_dejavnost == 404101) ? _c('span', [_vm._v("\r\n                                ZOBOZDRAVNIK ZA ODRASLE\r\n                                "), _c('md-icon', [_vm._v("face")])], 1) : _vm._e(), _vm._v(" "), (item.ZZZS_dejavnost == 404103) ? _c('span', [_vm._v("\r\n                                ZOBOZDRAVNIK ZA MLADINO\r\n                                "), _c('md-icon', [_vm._v("child_care")])], 1) : _vm._e()])]), _vm._v(" "), _c('md-card-media', [_c('div', {
      staticClass: "tooltip"
    }, [_c('md-icon', [_vm._v("info_outline")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "top"
      }
    }, [_vm._v("Doseganje povprečja pove, ali zobozdravnik sme zavrniti zavarovanca, ker že ima dovolj zavarovancev. Zavračati lahko začne nad 110% doseganja povprečja")])], 1), _vm._v(" "), _c('p', [_vm._v("Doseganje povprečja:")]), _vm._v(" "), _c('average', {
      attrs: {
        "average": item.doseganje_povprecja
      }
    })], 1)], 1)], 1)], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30836961","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dentists.vue
// module id = 67
// module chunks = 0